var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Mask.18efd334.png","uri@3x": __webpack_public_path__ + "static/media/Mask.35f02fcb.png","uri@2x": __webpack_public_path__ + "static/media/Mask.3c9bf566.png",
    width: 44,
    height: 25
});